function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#212f46;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-upload-cloud",
  transform: "translate(-.596 -3.734)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11904",
  d: "M19.927 21.964L15.964 18 12 21.964",
  className: "cls-1",
  transform: "translate(-3.968 -5.117)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11905",
  d: "M18 18v8.918",
  className: "cls-1",
  transform: "translate(-6.004 -5.415)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11906",
  d: "M20 18.917a4.651 4.651 0 0 0 2.34-5.267 4.757 4.757 0 0 0-4.622-3.528h-1.2a7.592 7.592 0 0 0-6.526-5.57 7.671 7.671 0 0 0-7.636 3.982 7.385 7.385 0 0 0 1.05 8.425",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11907",
  d: "M19.927 21.964L15.964 18 12 21.964",
  className: "cls-1",
  transform: "translate(-3.968 -5.117)"
}));

var SvgIconfeatherUploadCloud = function SvgIconfeatherUploadCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.708,
    height: 18.519,
    viewBox: "0 0 22.708 18.519",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconfeatherUploadCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon feather-upload-cloud.7ee6a6d4.svg";
export { ForwardRef as ReactComponent };